<template>
    <v-card>

        <v-card-title>
            <div class="title font-weight-light">Finalizar Atención</div>
        </v-card-title>

        <v-card-text>

          <v-flex xs12 >
            <v-select
                v-model="derivationType"
                label="Selecciona una opción"
                :items="derivationOptions" />
          </v-flex>

          <v-flex xs12 >
            <v-slide-y-transition>
              <specialist-picker
                  v-show="showSpecialistPicker"
                  ref="specialistPicker"
                  :filter="filterSpecialists"
                  :show-icon="false"
                  :value="specialist"
                  label="¿Quién revisará el/los exámen(es)?"
                  v-on:change="onSpecialistSelect"
                  :serviceProviderId="currentProvider.id" />
            </v-slide-y-transition>
          </v-flex>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click="$emit('cancel')">Cancelar</v-btn>
            <v-btn depressed
                   @click="confirm"
                   :disabled="!valid"
                   :loading="loading"
                   color="primary">Confirmar</v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
    import SpecialistPicker from "@/components/providers/SpecialistPicker";
    export default{
      components: {SpecialistPicker},
      props:{
            event: {
                type: Object
            },
            loading:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                derivationType: 'exam',
                specialist: null
            }
        },
        methods:{
          onSpecialistSelect(specialist){
            const vm = this
            vm.specialist = specialist
          },
          filterSpecialists(item){
            const vm = this
            if(!vm.currentUser) return item
            return item.id !== vm.currentUser.id
          },
          confirm(){
              var vm = this
              vm.$emit('confirm', {
                  derivation: {
                      type: vm.derivationType,
                      specialist_id: vm.specialist && vm.specialist.id || null
                  }
              })
          }
        },
        computed:{
            valid(){
              const vm = this
              return (vm.derivationType === 'exam' && !!vm.specialist) || vm.derivationType === 'discharge'
            },
            derivationOptions(){
              return [
                {
                  value: 'discharge',
                  text: 'No requiere acción posterior'
                },
                {
                  value: 'exam',
                  text: 'Requiere revisión de exámen(es)'
                }
              ]
          },
          showSpecialistPicker(){
              const vm = this
              return vm.derivationType === 'exam'
          }
        }
    }
</script>